import { ActiveDescendantKeyManager } from '@angular/cdk/a11y';
import {
  AfterContentInit,
  booleanAttribute,
  Component,
  ContentChildren,
  Input,
  OnDestroy,
  QueryList,
  signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';

import { AutocompleteOptionDirective } from './autocomplete-option.directive';

@Component({
  selector: 'tt-autocomplete',
  standalone: true,
  styleUrl: 'autocomplete.component.scss',
  exportAs: 'ttAutocomplete',
  template: `
    <ng-template>
      <div #panel class="tt-autocomplete" role="listbox" [class.tt-autocomplete--hidden]="!showPanel()">
        <ng-content />
      </div>
    </ng-template>
  `,
})
export class AutocompleteComponent<T> implements AfterContentInit, OnDestroy {
  @Input({ transform: booleanAttribute }) public requireSelection: boolean;

  @ContentChildren(AutocompleteOptionDirective, { descendants: true }) public options: QueryList<AutocompleteOptionDirective<T>>;
  @ViewChild(TemplateRef) public template!: TemplateRef<unknown>;

  public keyManager!: ActiveDescendantKeyManager<AutocompleteOptionDirective<T>>;
  public showPanel = signal(false);

  public ngAfterContentInit(): void {
    this.keyManager = new ActiveDescendantKeyManager(this.options)
      .withWrap()
      .withPageUpDown()
      .skipPredicate((item) => item.disabled);
    setTimeout(() => this.keyManager.setFirstItemActive());

    this.options.changes.subscribe(() => this.setVisibility());
  }

  public ngOnDestroy(): void {
    this.keyManager.destroy();
  }

  public setVisibility(): void {
    this.showPanel.set(!!this.options.length);
  }
}
